module.exports = __webpack_public_path__ + "img/small-1.d62c0a69.jpg";